export const ROUTE_NAMES = {
  events: {
    card: 'EventsCardVES',
  },
};
